import styled from 'styled-components';

export const StyledSpan = styled.span`
  color: ${({ theme }) => theme.colors.primary.blue};
`;

export const ActionContainer = styled.div`
  & > div {
    margin-right: 5px;
  }
`;
